import React from 'react'

const useToggle = (initialState: boolean) => {
  const [open, setOpen] = React.useState(initialState)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen(!open)
  }

  return { open, handleOpen, handleClose, handleToggle }
}

export default useToggle
